import apiAuth from '@/apis/auth'
import apiUser from '@/apis/user'
import { PublicClientApplication } from '@azure/msal-browser'

// import router from '@/router'
import {
  setToken,
  removeToken,
  setRefreshToken,
  removeRefreshToken
} from '@/utils/auth'

const state = {
  user: {
    _id: '',
    avatar: '',
    displayname: '',
    email: '',
    auth_type: '',
    is_active: false,
    is_change_password: false,
    is_delete: false,
    last_login: '',
    role: {},
    created_at: '',
    auth: false,
    is_system_user: false
  },
  show_campaign_active: true,
  azure_params: null
}

const actions = {
  async login({ commit }, { email, password }) {
    try {
      const authResponse = await apiAuth.login({ email, password })

      if (authResponse.code === 0) {
        const res = authResponse.data
        setToken(res.token)
        setRefreshToken(res.refresh_token)

        const user = {
          _id: res.user._id,
          avatar: res.user.avatar,
          displayname: res.user.displayname,
          email: res.user.email,
          auth_type: res.user.auth_type,
          is_active: res.user.is_active,
          is_change_password: res.user.is_change_password,
          is_delete: res.user.is_delete,
          last_login: res.user.last_login,
          role: res.role,
          created_at: res.user.created_at,
          auth: true,
          is_system_user: res.user.is_system_user
        }

        commit('setUser', user)
      }
      return authResponse
    } catch (error) {
      return error
    }
  },
  async loginGoogle({ commit }, data) {
    try {
      const authResponse = await apiAuth.loginGoogle(data)

      if (authResponse.code === 0) {
        const res = authResponse.data
        setToken(res.token)
        setRefreshToken(res.refresh_token)

        const user = {
          _id: res.user._id,
          avatar: res.user.avatar,
          displayname: res.user.displayname,
          email: res.user.email,
          auth_type: res.user.auth_type,
          is_active: res.user.is_active,
          is_change_password: res.user.is_change_password,
          is_delete: res.user.is_delete,
          last_login: res.user.last_login,
          role: res.role,
          created_at: res.user.created_at,
          auth: true,
          is_system_user: res.user.is_system_user
        }
        commit('setUser', user)
      }
      return authResponse
    } catch (error) {
      return error
    }
  },
  async loginAzure({ commit }, data) {
    try {
      const authResponse = await apiAuth.loginAzure(data)

      if (authResponse.code === 0) {
        const res = authResponse.data
        setToken(res.token)
        setRefreshToken(res.refresh_token)

        const user = {
          _id: res.user._id,
          avatar: res.user.avatar,
          displayname: res.user.displayname,
          email: res.user.email,
          auth_type: res.user.auth_type,
          is_active: res.user.is_active,
          is_change_password: res.user.is_change_password,
          is_delete: res.user.is_delete,
          last_login: res.user.last_login,
          role: res.role,
          created_at: res.user.created_at,
          auth: true
        }
        commit('setUser', user)
      }
      return authResponse
    } catch (error) {
      return error
    }
  },
  logout({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        commit('logout')

        await apiAuth.logout()

        removeToken()
        removeRefreshToken()

        resolve()
      } catch (error) {
        reject(error)
      }
    })
  },
  updateProfile({ commit }, { id, obj }) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await apiUser.updateUser(id, obj)

        await commit('updateProfile', obj)

        resolve(res)
      } catch (error) {
        reject(error)
      }
    })
  },

  setAzureParams({ commit }, data) {
    return new Promise(async (resolve, reject) => {
      try {
        await commit('setAzureParams', data)

        resolve()
      } catch (error) {
        reject(error)
      }
    })
  },

  setShowCampaignActive({ commit }, isActive) {
    return new Promise(async (resolve, reject) => {
      try {
        await commit('setShowCampaignActive', isActive)

        resolve(true)
      } catch (error) {
        reject(error)
      }
    })
  },
  frontendLogout({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        commit('logout')

        removeToken()
        removeRefreshToken()

        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }
}

const mutations = {
  setUser(state, user) {
    state.user = user
  },
  async logout(state) {
    if (state.user.auth_type === 'azure') {
      const azure_client = new PublicClientApplication(state.azure_params)
      await azure_client.logoutPopup()
    }

    state.user = {
      _id: '',
      avatar: '',
      displayname: '',
      email: '',
      auth_type: '',
      is_active: false,
      is_change_password: false,
      is_delete: false,
      last_login: '',
      role: {},
      created_at: '',
      auth: false,
      is_system_user: false
    }
    state.show_campaign_active = true
  },
  updateProfile(state, obj) {
    state.user.avatar = obj.avatar
    state.user.displayname = obj.displayname
  },
  setAzureParams(state, data) {
    state.azure_params = data
  },
  setShowCampaignActive(state, isActive) {
    state.show_campaign_active = isActive
  }
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    user: state => state.user,
    show_campaign_active: state => state.show_campaign_active,
    azure_params: state => state.azure_params
  }
}
